.iconContainer {
  display: flex;
}
